import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <Header />
      <main className="flex-grow py-6 sm:py-8 px-4 overflow-x-hidden">
        <div className="container mx-auto max-w-full overflow-x-hidden">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};
